import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=5b8601a6&scoped=true"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./ButtonGroup.vue?vue&type=style&index=0&id=5b8601a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8601a6",
  null
  
)

export default component.exports